import React from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";
import BlogPage from "../../../subsreens/gcstudent/Blog/BlogPage";
import HeroSection from "../../../components/gcstudent/aboutsection/HeroSection";
// import GcStudentContactUs from "../../../subscreens/gcstudent/ContactUs/GcStudentContactUs";
const GcBlog = () => {
    const BlogsData = { title: 'Blogs', highLight: 'GGCW', subTitle: 'Read the latest articles on education, technology, and library resources.' };

    return (
        <>
            <GcStudentMasterLayout>
             <HeroSection  heroData={ BlogsData}/>
             <BlogPage/>
            </GcStudentMasterLayout>
        </>
    );
};

export default GcBlog;